import * as _ from 'lodash';
import {Site} from "../api/model/site";
import {Role} from "../api/model/role";
import {Theme} from "../api/model/theme";
import {Schema} from "../api/model/schema";

const environment = {
    test: {
        S3_BUCKET: 'sintesis-test',
        S3_ENDPOINT: 'https://s3.eu-west-1.amazonaws.com/sintesis-test',
    },
    prod: {
        S3_BUCKET: 'sintesis-prod',
        S3_ENDPOINT: 'https://s3.eu-west-1.amazonaws.com/sintesis-prod',
    }
};

const common = {
    STAGE: process.env.STAGE,
    DATE_FORMAT: 'MMMM DD YYYY',
    S3_PREFIX: 'users/',
};

interface Config {
    identityId?: string;
    STAGE?: string;
    DATE_FORMAT?: string;
    S3_PREFIX?: string;
    S3_BUCKET?:string,
    S3_ENDPOINT?:string,
    sites: Site[];
    site: Site;
    roles: Role[];
    themes: Theme[];
    schemas: Schema[];
}

export const config: Config = _.merge({}, common, environment[process.env.STAGE]);


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/config.ts